import { ComponentType } from 'react';
import { SvgIconProps } from '@mui/material';

import {
  PromotionIcon,
  RewardIcon,
  ProductGroupsIcon,
  ChallengeIcon,
  CasinoIcon,
  LocalOfferIcon,
  LayersIcon,
  AwardCatalogIcon,
  FuelRollbackIcon,
  SweepstakesOfferIcon,
  AspectRatioIcon,
  EventIcon,
  CategoryIcon,
  GameIcon,
  SendIcon,
  PromocodeIcon,
  JoystickIcon,
  MessageOutlinedIcon,
  SavingsOutlinedIcon,
} from '@occc/ui-design-system/icons';
import { ToolboxItemType } from './types';

export const getAvatarIconTestId = (type: ToolboxItemType): string => `${type}-icon`;
export const getAvatarTestId = (type: ToolboxItemType): string => `${type}-avatar`;
export const getCreateButtonTestId = (type: ToolboxItemType): string => `${type}-create-button`;
export const getEditButtonTestId = (type: ToolboxItemType): string => `${type}-edit-button`;
export const getDetailsButtonTestId = (type: ToolboxItemType): string => `${type}-details-button`;

export const toolboxIcons: Record<ToolboxItemType, ComponentType<SvgIconProps>> = {
  [ToolboxItemType.Offer]: LocalOfferIcon,
  [ToolboxItemType.Reward]: RewardIcon,
  [ToolboxItemType.Promotion]: PromotionIcon,
  [ToolboxItemType.Promocodes]: PromocodeIcon,
  [ToolboxItemType.Punchcard]: CasinoIcon,
  [ToolboxItemType.Challenge]: ChallengeIcon,
  [ToolboxItemType.ProductGroups]: ProductGroupsIcon,
  [ToolboxItemType.AwardCatalog]: AwardCatalogIcon,
  [ToolboxItemType.DisplayCategory]: LayersIcon,
  [ToolboxItemType.ProductCategory]: CategoryIcon,
  [ToolboxItemType.FuelRollback]: FuelRollbackIcon,
  [ToolboxItemType.Sweepstakes]: SweepstakesOfferIcon,
  [ToolboxItemType.Billboards]: AspectRatioIcon,
  [ToolboxItemType.LoyaltyEvents]: EventIcon,
  [ToolboxItemType.FreeGames]: GameIcon,
  [ToolboxItemType.VoucheredGames]: GameIcon,
  [ToolboxItemType.ReferralProgram]: SendIcon,
  [ToolboxItemType.SmsOrPushNotification]: JoystickIcon,
  [ToolboxItemType.TriggeredMessages]: MessageOutlinedIcon,
  [ToolboxItemType.StoredValue]: SavingsOutlinedIcon,
};
